import { render, staticRenderFns } from "./EvaluatorCommitteeModal.vue?vue&type=template&id=37a9187e&scoped=true"
import script from "./EvaluatorCommitteeModal.vue?vue&type=script&lang=js"
export * from "./EvaluatorCommitteeModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a9187e",
  null
  
)

export default component.exports